var screen_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
var desktopMinWidth = 1280;

document.addEventListener('DOMContentLoaded', event => {
  const body = document.getElementsByTagName('body')[0];

  if (body.classList.contains('front-page')) {
    if (document.getElementsByTagName('html')[0].getAttribute('lang') == 'en-US') {
      var menu = document.getElementById('menu-paavalikko-en-1');
    } else {
      var menu = document.getElementById('menu-paavalikko-1');
    }
    const header = document.getElementById('masthead');
    const firstH1 = document.getElementsByTagName('h1')[0];
    const options = {
      root: null,
    }

    // Set menu orientation with classes
    function verticalMenu(vertical) {
      // If desktop menu
      if (screen_w > desktopMinWidth) {
        if (vertical) {
          body.classList.add('vertical-menu');

          void menu.offsetWidth;
          header.classList.add('vertical');

          void header.offsetWidth;
          header.classList.remove('horizontal');

          // position: sticky polyfill for IE 11
          Stickyfill.remove(header);
        } else {
          body.classList.remove('vertical-menu');

          void menu.offsetWidth;
          header.classList.remove('vertical');

          void header.offsetWidth;
          header.classList.add('horizontal');

          // position: sticky polyfill for IE 11
          Stickyfill.add(header);
        }
      }
    }

    // Observe when vertical menu element is in view
    const menuObserver = new IntersectionObserver(menuObserverCallback, options);
    menuObserver.observe(menu);

    function menuObserverCallback (entries, observer)  {
      entries.forEach(entry => {
        // When vertical menu goes out of view
        if (entry.intersectionRatio == 0) {
          if (header.classList.contains('vertical')) {
            verticalMenu(false);
          }
        }
      });
    };

    // Observe when first h1 is in view
    const headerObserver = new IntersectionObserver(headerObserverCallback, options);
    headerObserver.observe(firstH1);

    function headerObserverCallback (entries, observer)  {
      entries.forEach(entry => {
        // When first header comes into view when scrolling up
        if (entry.intersectionRatio > 0) {
          if (!header.classList.contains('vertical')) {
            verticalMenu(true);
          }
        }
      });
    };
  }
});



